import styled from "vue-styled-components";

export const CFormGroup = styled.div`
    label {
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    }

    input, select, textarea {
        background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'} !important;
        border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
        border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'};
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        outline: none;

        &::placeholder {
            color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        }

        &:focus {
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
        }
    }
`

export const CHeading2 = styled.h2`
    color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
`

export const CHeading3 = styled.h3`
    color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
`

export const CHeading4 = styled.h4`
    color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
`

export const CSpan = styled.span`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
`

export const CParagraph = styled.p`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
`

export const CLabel = styled.label`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'} !important;
`

export const CLink = styled.a`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'} !important;
`

export const CSmall = styled.small`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
`

export const CTable = styled.table`
    thead th, th, td {
        border-color: ${props => props.theme?.border_color_site ?? '#dee2e6'};
    }
    th, td {
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    }
`

export const CPrimaryTitle = styled.h1`
    color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
    display: block;
    font: 600 1.92rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
    margin: 0 0 2.5rem;//3.3rem;
    position: relative;
    text-transform: uppercase;
    /* &:after {
        background-color: ${props => props.theme?.secondary_color};
        bottom: -.9rem;
        content: '';
        display: block;
        height: .25rem;
        left: 0;
        position: absolute;
        width: 1.3rem;
    } */
`

export const CSecondaryTitle = styled.h2`
    color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
    display: block;
    font: 400 1.8rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    margin: 0 0 2.5rem;//3.3rem;
    position: relative;
    text-transform: uppercase;
    /* &:after {
        background-color: ${props => props.theme?.secondary_color};
        bottom: -.9rem;
        content: '';
        display: block;
        height: .2rem;
        left: 0;
        position: absolute;
        width: 1.1rem;
    } */

    &.related-title {
        font-size: 1.2rem;
        margin: 0;
        letter-spacing: 0.05em;
    }
`